import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
const FooterWrapper = styled.div`
    margin-top:6rem;
`
const FooterLogo = styled.h1`
text-align:center;
font-family: 'Babe Sans';
font-style: normal;
font-weight: 400;
font-size: 24px;
line-height: 30px;
letter-spacing: -0.5px;
color: #000000;
@media screen and (max-width:570px)
{
    text-align:start;
}
`
const FooterDescription = styled.div`
display:flex;
flex-direction: column;

align-items: center;
margin-bottom: 2rem;
@media screen and (max-width:570px)
{
    align-items: start;
}
`
const FooterTitle = styled.h1`
font-weight: 600;
font-size: 30px;
line-height: 38px;
text-align: center;
@media screen and (max-width:570px)
{
    text-align: start;
}
`
const FooterParagraph = styled.p`
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #667085;
`
const FooterArea = styled.footer`
/* display:flex;
flex-direction:row;
align-items: center;
border-top: 1px solid  #E4E7EC;
margin-top:3rem; */
display:flex;
flex-direction:column;
border-top: 1px solid  #E4E7EC;
`
const FooterCopyright = styled.p`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #98A2B3;
    flex: 1;
`
const FooterLinks = styled.div`
display: flex;
flex-direction: row;
gap: 1rem;
`
const LinkFooter = styled(Link)`
    font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #98A2B3;
`
const FooterSection = styled.div`
display:flex;
flex-direction:row;
align-items: center;
width: 100%;
margin-top:2rem;
margin-bottom:-2rem;
@media screen and (max-width:570px)
{
    align-items: start;
    flex-direction: column-reverse;
}

`
const FooterFooter = styled.div`
display:flex;
flex-direction:row;
align-items: center;
width: 100%;
margin-top:2rem;
margin-bottom:-2rem;
svg{
        cursor:pointer;
    }
@media screen and (max-width:570px)
    {

        margin-top: 2rem;;
    }
`
const FooterSocial = styled.div`
    flex: 1;
    @media screen and (max-width:570px)
    {

        flex: 0.15;
    }
`
function Footer() {
  return (
    <FooterWrapper className='footer'>
        <FooterLogo>
        Al Sabab 
        </FooterLogo>
        <FooterDescription>
            <FooterTitle>
            Breaking news du monde musulman
            </FooterTitle>
            {/* <FooterDescription>
            Join over 4,000+ startups already growing with Untitled.
            </FooterDescription> */}
        </FooterDescription>
        <FooterArea>
            <FooterSection>
            <FooterCopyright>
        © 2022 Al Sabab. All rights reserved.
        </FooterCopyright>
        <FooterLinks>
            <LinkFooter to='/terms'>Terms</LinkFooter>
            <LinkFooter to='/privacy'>Privacy</LinkFooter>
            <LinkFooter to='/cookies'>Cookies</LinkFooter>
        </FooterLinks>
            </FooterSection>
            <FooterFooter>
                <FooterSocial>
                <a href='https://www.instagram.com/alsabab_fr/' target="_blank">
                <svg   width="35" height="35" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5758 0.00025034C25.7415 0.00887034 26.5161 0.0398134 28.2612 0.122638C30.3871 0.21635 31.841 0.560063 33.1147 1.05243C34.4435 1.55243 35.6549 2.34181 36.6554 3.35769C37.6795 4.358 38.4611 5.5613 38.9691 6.90532C39.4616 8.1715 39.8053 9.63274 39.8991 11.7582C39.9794 13.5868 39.9967 14.3475 40 17.9476L40.0004 21.0958C39.997 25.538 39.9705 26.2656 39.8835 28.2467C39.7898 30.3721 39.4457 31.8257 38.9535 33.0995C37.9139 35.7876 35.788 37.913 33.0992 38.9524C31.833 39.4448 30.3715 39.7885 28.2456 39.8822C26.1118 39.9762 25.4319 39.9994 19.9998 39.9994L19.4356 39.9993C14.5172 39.9977 13.8112 39.9729 11.7539 39.8822C9.6277 39.7885 8.17411 39.4448 6.90004 38.9524C5.57132 38.4524 4.35984 37.663 3.35934 36.6472C2.34326 35.6469 1.55403 34.4436 1.04599 33.0995C0.553519 31.8334 0.209432 30.3721 0.115702 28.2467C0.0387085 26.4942 0.00909692 25.7226 0.000976562 22.4927L0.00122738 17.4345C0.0098491 14.2695 0.0407983 13.4951 0.12364 11.7503C0.21737 9.6248 0.561152 8.1715 1.05362 6.89769C1.55403 5.56924 2.34326 4.358 3.35934 3.35769C4.35984 2.33388 5.56338 1.55243 6.90798 1.0445C8.17411 0.552432 9.63564 0.208414 11.7615 0.114702C13.5143 0.0377239 14.2861 0.00811872 17.5166 0L22.5758 0.00025034ZM22.1089 3.63289H17.9402C14.4648 3.6397 13.739 3.66858 11.9414 3.74841C9.99529 3.83449 8.9322 4.16264 8.22876 4.43614C7.36106 4.75635 6.57946 5.26429 5.93098 5.92852C5.25868 6.56954 4.75064 7.35862 4.43007 8.22614C4.15651 8.92944 3.8283 9.98439 3.7425 11.938C3.65543 13.8843 3.62909 14.5777 3.62566 18.9067V21.1291C3.62909 25.4572 3.65543 26.1447 3.7425 28.0983C3.8283 30.044 4.15651 31.1069 4.43007 31.8102C4.75064 32.6774 5.25868 33.4588 5.92304 34.1075C6.56389 34.7717 7.35343 35.2796 8.22082 35.6002C8.92426 35.8737 9.97942 36.2018 11.9334 36.2876C13.7246 36.3677 14.455 36.3964 17.932 36.4031H22.0982C25.5737 36.3964 26.2993 36.3677 28.0969 36.2876C30.0433 36.2018 31.1061 35.8737 31.8095 35.6002C33.5526 34.928 34.9359 33.5449 35.6082 31.8022C35.8818 31.0989 36.21 30.044 36.2961 28.0904C36.3794 26.2149 36.4072 25.5126 36.4124 21.6311V18.4047C36.4072 14.5218 36.3794 13.8135 36.2961 11.938C36.21 9.99202 35.8818 8.92944 35.6082 8.22614C35.2876 7.35862 34.7796 6.57718 34.1152 5.92852C33.4744 5.26429 32.6849 4.75635 31.8175 4.43614C31.114 4.16264 30.0589 3.83449 28.1049 3.74841C26.3137 3.66858 25.5891 3.6397 22.1089 3.63289ZM20.0074 9.72645C25.6819 9.72645 30.2854 14.329 30.2854 20.0024C30.2854 25.6758 25.6819 30.2784 20.0074 30.2784C14.3332 30.2784 9.72937 25.6758 9.72937 20.0024C9.72937 14.329 14.3332 9.72645 20.0074 9.72645ZM20.0074 13.3367C16.3262 13.3367 13.3403 16.3217 13.3403 20.0024C13.3403 23.6831 16.3262 26.6682 20.0074 26.6682C23.6888 26.6682 26.6745 23.6831 26.6745 20.0024C26.6745 16.3217 23.6888 13.3367 20.0074 13.3367ZM30.6918 6.92119C32.0171 6.92119 33.0915 7.99507 33.0915 9.32016C33.0915 10.645 32.0171 11.7191 30.6918 11.7191C29.3667 11.7191 28.2923 10.645 28.2923 9.32016C28.2923 7.99507 29.3667 6.92119 30.6918 6.92119Z" fill="black"/>
</svg>
</a>

                </FooterSocial>
              <FooterSocial style={{textAlign: 'end'}}>
                <a href='https://twitter.com/alsababfr' target="_blank">
                <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M44 11.7883C42.5125 12.4308 40.9275 12.8566 39.275 13.0634C40.975 12.064 42.2725 10.4935 42.8825 8.60062C41.2975 9.53108 39.5475 10.1883 37.6825 10.5551C36.1775 8.97723 34.0325 8 31.6925 8C27.1525 8 23.4975 11.6283 23.4975 16.0763C23.4975 16.7163 23.5525 17.3317 23.6875 17.9175C16.87 17.5902 10.8375 14.3729 6.785 9.472C6.0775 10.6806 5.6625 12.064 5.6625 13.5532C5.6625 16.3495 7.125 18.8283 9.305 20.2634C7.9875 20.2388 6.695 19.8622 5.6 19.2689C5.6 19.2935 5.6 19.3255 5.6 19.3575C5.6 23.2812 8.4425 26.5403 12.17 27.2911C11.5025 27.4708 10.775 27.5569 10.02 27.5569C9.495 27.5569 8.965 27.5274 8.4675 27.4191C9.53 30.6166 12.545 32.9674 16.13 33.0437C13.34 35.1926 9.7975 36.4874 5.9625 36.4874C5.29 36.4874 4.645 36.4578 4 36.3766C7.6325 38.6831 11.9375 40 16.58 40C31.67 40 39.92 27.6923 39.92 17.024C39.92 16.6671 39.9075 16.3225 39.89 15.9803C41.5175 14.8431 42.885 13.4228 44 11.7883Z" fill="black"/>
</svg>
                </a>
             

</FooterSocial>
              
            </FooterFooter>
        </FooterArea>
    </FooterWrapper>
  )
}

export default Footer